import React, { useState, useEffect, useCallback, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {

  faHome,

  faChevronRight,
  faChevronLeft,

  faCheckDouble,

  faUsers,

  faChevronDown,
  faLayerGroup,
  faUserGear,

  faUserAstronaut,
  faBook,

} from '@fortawesome/free-solid-svg-icons';
import { FaTripadvisor } from 'react-icons/fa';
import { faReadme } from '@fortawesome/free-brands-svg-icons';

// Configuration des sections
const SECTION_CONFIG = [
  {
    id: 'main',
    label: 'Principal',
    icon: faHome,
    items: [
      { to: '/Home', icon: faHome, label: 'Vue d\'ensemble' }
    ]
  },


  {
    id: 'hr',
    label: 'Ressource Humaine',
    icon: faUsers,
    items: [
      { to: '/evaluationEmploye', icon: faCheckDouble, label: 'Évaluation' },
      { to: '/supervision', icon: faUserAstronaut, label: 'Mission & Supervision' }
    ]
  },
   {
      id: 'tuto',
      label: 'Tutoriels',
      icon: faReadme,
      items: [
        { to: '/presentation', icon: faBook, label: 'Presentation' },
        { to: '/TutoRH', icon: faReadme, label: 'Ressource Humaine' },

       
      ]
    }


];

const SidebarSuperVisor = ({ userId, fonction, onLinkClick, logo, nom }) => {
  const location = useLocation();
  
  // Persistance de l'état rétracté
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebar_collapsed_state');
    return saved ? JSON.parse(saved) : false;
  });

  // Persistance des sections ouvertes
  const [expandedSections, setExpandedSections] = useState(() => {
    const saved = localStorage.getItem('sidebar_expanded_sections');
    if (saved) {
      try { return JSON.parse(saved); } 
      catch { /* fallthrough */ }
    }
    // Par défaut, tout ouvrir
    const defaultOpen = {};
    SECTION_CONFIG.forEach(s => { defaultOpen[s.id] = true; });
    return defaultOpen;
  });

  // Auto-ouvrir la section contenant le lien actif
  useEffect(() => {
    const activeSection = SECTION_CONFIG.find(section =>
      section.items.some(item => location.pathname.startsWith(item.to))
    );
    if (activeSection && !expandedSections[activeSection.id]) {
      setExpandedSections(prev => ({ ...prev, [activeSection.id]: true }));
    }
  }, [location.pathname]);

  // Sauvegarde des préférences
  useEffect(() => {
    localStorage.setItem('sidebar_collapsed_state', JSON.stringify(isCollapsed));
  }, [isCollapsed]);

  useEffect(() => {
    localStorage.setItem('sidebar_expanded_sections', JSON.stringify(expandedSections));
  }, [expandedSections]);

  const toggleSection = useCallback((sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  }, []);

  const handleLinkClick = () => {
    if (onLinkClick) onLinkClick();
  };

  // Vérifier si une section a un lien actif
  const isSectionActive = (items) => {
    return items.some(item => location.pathname.startsWith(item.to));
  };

  // Extraire l'initiale pour l'avatar
  const userInitial = (fonction || 'U').charAt(0).toUpperCase();

  return (
    <>
      <style>{`
        /* ============================================================
           SIDEBAR ULTRA PREMIUM – GLASSMORPHISM LUXE
           ============================================================ */
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

        :root {
          --glass-bg: rgba(8, 15, 35, 0.82);
          --glass-border: rgba(59, 130, 246, 0.15);
          --glass-shadow: 0 25px 50px rgba(0, 0, 0, 0.6);
          --primary-blue: #3b82f6;
          --accent-cyan: #38bdf8;
          --primary-glow: rgba(59, 130, 246, 0.4);
          --text-light: #e8edff;
          --text-muted: #94a3b8;
          --radius-lg: 24px;
          --radius-md: 14px;
          --transition-smooth: cubic-bezier(0.22, 1, 0.36, 1);
        }

        /* --- CONTENEUR PRINCIPAL --- */
        .glass-sidebar-content {
          height: 100vh;
          width: 280px;
          display: flex;
          flex-direction: column;
          background: var(--glass-bg);
          backdrop-filter: blur(24px) saturate(1.4);
          -webkit-backdrop-filter: blur(24px) saturate(1.4);
          border-right: 1px solid var(--glass-border);
          border-radius: 0 32px 32px 0;
          box-shadow: var(--glass-shadow), inset 0 1px 0 rgba(255,255,255,0.03);
          transition: width 0.5s var(--transition-smooth);
          overflow: visible;
          position: relative;
          z-index: 1040;
          color: var(--text-light);
          font-family: 'Inter', -apple-system, sans-serif;
        }

        .glass-sidebar-content.collapsed {
          width: 80px;
        }

        /* --- TOGGLE HANDLE (CERCLE FLOTTANT) --- */
        .toggle-handle {
          position: absolute;
          right: -20px;
          top: 50%;
          transform: translateY(-50%);
          width: 40px;
          height: 40px;
          background: rgba(10, 20, 50, 0.9);
          backdrop-filter: blur(12px);
          border: 1.5px solid var(--glass-border);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--primary-blue);
          cursor: pointer;
          transition: all 0.4s var(--transition-smooth);
          box-shadow: 0 4px 20px rgba(0,0,0,0.3);
          z-index: 10;
        }
        .toggle-handle:hover {
          color: white;
          background: var(--primary-blue);
          border-color: var(--primary-blue);
          transform: translateY(-50%) scale(1.1);
          box-shadow: 0 0 30px var(--primary-glow);
        }
        .toggle-handle:active { transform: translateY(-50%) scale(0.9); }

        /* --- HEADER --- */
        .sidebar-header {
          flex-shrink: 0;
          padding: 28px 20px 20px 20px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 14px;
          border-bottom: 1px solid rgba(255,255,255,0.03);
          min-height: 80px;
        }
        .glass-sidebar-content.collapsed .sidebar-header {
          justify-content: center;
          padding: 28px 0 20px 0;
        }

        .app-brand {
          display: flex;
          align-items: center;
          gap: 10px;
          text-decoration: none;
        }
        .brand-icon-wrapper {
          width: 40px;
          height: 40px;
          border-radius: 12px;
          background: linear-gradient(135deg, var(--primary-blue), var(--accent-cyan));
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.2rem;
          box-shadow: 0 4px 16px var(--primary-glow);
          flex-shrink: 0;
        }
        .brand-text {
          font-weight: 800;
          font-size: 1.2rem;
          letter-spacing: -0.5px;
          color: white;
          white-space: nowrap;
        }
        .brand-highlight {
          background: linear-gradient(135deg, #60a5fa, #3b82f6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .brand-sub {
          font-size: 0.6rem;
          font-weight: 600;
          color: var(--text-muted);
          letter-spacing: 2px;
          text-transform: uppercase;
          opacity: 0.6;
          margin-top: 2px;
        }

        /* --- SCROLLBAR --- */
        .sidebar-scroll {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 16px 12px 20px 12px;
          scroll-behavior: smooth;
        }
        .glass-sidebar-content.collapsed .sidebar-scroll { padding: 16px 6px 20px 6px; }

        .sidebar-scroll::-webkit-scrollbar { width: 3px; }
        .sidebar-scroll::-webkit-scrollbar-track { background: transparent; }
        .sidebar-scroll::-webkit-scrollbar-thumb {
          background: var(--primary-blue);
          border-radius: 10px;
          opacity: 0.3;
        }

        /* ============================================================
           SECTION ACCORDÉON
           ============================================================ */
        .sidebar-section {
          margin-bottom: 6px;
          border-radius: var(--radius-md);
          transition: all 0.3s ease;
        }

        .sidebar-section-header {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 14px;
          border-radius: var(--radius-md);
          cursor: pointer;
          transition: all 0.3s var(--transition-smooth);
          user-select: none;
          background: transparent;
          border: none;
          width: 100%;
          text-align: left;
          color: var(--text-muted);
          font-family: 'Inter', sans-serif;
          font-size: 0.7rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          position: relative;
        }
        .sidebar-section-header:hover {
          background: rgba(255,255,255,0.04);
          color: var(--text-light);
        }
        .sidebar-section-header.active {
          color: var(--accent-cyan);
        }
        .sidebar-section-header .section-icon {
          font-size: 0.9rem;
          width: 22px;
          opacity: 0.5;
          transition: all 0.3s ease;
        }
        .sidebar-section-header.active .section-icon {
          opacity: 1;
          color: var(--accent-cyan);
        }
        .sidebar-section-header .section-label {
          flex: 1;
          font-weight: 700;
          letter-spacing: 1px;
        }
        .sidebar-section-header .section-chevron {
          font-size: 0.6rem;
          transition: transform 0.4s var(--transition-smooth);
          opacity: 0.4;
        }
        .sidebar-section-header .section-chevron.open {
          transform: rotate(180deg);
          color: var(--accent-cyan);
          opacity: 1;
        }

        /* Indicateur de section active (barre gauche) */
        .sidebar-section-header .section-indicator {
          position: absolute;
          left: -12px;
          width: 3px;
          height: 20px;
          border-radius: 4px;
          background: transparent;
          transition: all 0.3s ease;
        }
        .sidebar-section-header.active .section-indicator {
          background: var(--accent-cyan);
          box-shadow: 0 0 20px var(--primary-glow);
        }

        .sidebar-section-content {
          overflow: hidden;
          transition: max-height 0.5s var(--transition-smooth), opacity 0.4s ease;
          max-height: 0;
          opacity: 0;
        }
        .sidebar-section-content.open {
          max-height: 800px;
          opacity: 1;
        }

        /* ============================================================
           LIENS DE NAVIGATION
           ============================================================ */
        .nav-link-glass {
          position: relative;
          display: flex;
          align-items: center;
          padding: 10px 14px 10px 20px;
          margin-bottom: 2px;
          border-radius: var(--radius-md);
          color: var(--text-muted);
          text-decoration: none;
          transition: all 0.3s var(--transition-smooth);
          border: 1px solid transparent;
          white-space: nowrap;
          cursor: pointer;
          background: transparent;
          font-size: 0.9rem;
          font-weight: 500;
          gap: 14px;
          overflow: hidden;
        }
        .nav-link-glass:hover {
          background: rgba(59, 130, 246, 0.06);
          color: white;
          transform: translateX(4px);
          border-color: rgba(59, 130, 246, 0.06);
        }
        .nav-link-glass.active {
          background: rgba(59, 130, 246, 0.1);
          color: white;
          border-color: rgba(59, 130, 246, 0.15);
          box-shadow: inset 0 0 30px rgba(59, 130, 246, 0.02);
        }

        /* Glow active (barre gauche) */
        .nav-link-glass::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%) scaleY(0);
          width: 3px;
          height: 20px;
          border-radius: 4px;
          background: var(--accent-cyan);
          box-shadow: 0 0 20px var(--primary-glow);
          transition: transform 0.3s var(--transition-smooth);
        }
        .nav-link-glass.active::before {
          transform: translateY(-50%) scaleY(1);
        }

        .nav-link-glass .link-icon {
          width: 20px;
          display: flex;
          justify-content: center;
          font-size: 1rem;
          transition: all 0.3s var(--transition-smooth);
          flex-shrink: 0;
        }
        .nav-link-glass.active .link-icon {
          color: var(--accent-cyan);
          filter: drop-shadow(0 0 8px var(--primary-glow));
        }

        .nav-link-glass .link-text {
          flex: 1;
          font-size: 0.85rem;
        }
        .nav-link-glass .link-chevron {
          font-size: 0.55rem;
          opacity: 0;
          transform: translateX(-8px);
          transition: all 0.4s var(--transition-smooth);
          color: var(--accent-cyan);
        }
        .nav-link-glass.active .link-chevron {
          opacity: 1;
          transform: translateX(0);
        }

        /* ============================================================
           MODE RÉTRACTÉ
           ============================================================ */
        .glass-sidebar-content.collapsed .nav-link-glass {
          padding: 0;
          margin: 0 auto 4px auto;
          justify-content: center;
          width: 48px;
          height: 48px;
          border-radius: 14px;
          background: rgba(255,255,255,0.02);
          border: 1px solid transparent;
        }
        .glass-sidebar-content.collapsed .nav-link-glass:hover {
          transform: translateY(-2px) scale(1.05);
          background: rgba(59, 130, 246, 0.1);
        }
        .glass-sidebar-content.collapsed .nav-link-glass.active {
          background: rgba(59, 130, 246, 0.15);
          border-color: rgba(59, 130, 246, 0.2);
          box-shadow: 0 0 30px var(--primary-glow);
        }
        .glass-sidebar-content.collapsed .nav-link-glass::before { display: none; }
        .glass-sidebar-content.collapsed .nav-link-glass .link-text,
        .glass-sidebar-content.collapsed .nav-link-glass .link-chevron {
          display: none;
        }
        .glass-sidebar-content.collapsed .nav-link-glass .link-icon {
          font-size: 1.2rem;
        }

        /* Sections rétractées */
        .glass-sidebar-content.collapsed .sidebar-section-header {
          padding: 8px 0;
          justify-content: center;
          margin-bottom: 2px;
        }
        .glass-sidebar-content.collapsed .sidebar-section-header .section-label,
        .glass-sidebar-content.collapsed .sidebar-section-header .section-chevron,
        .glass-sidebar-content.collapsed .sidebar-section-header .section-indicator {
          display: none;
        }
        .glass-sidebar-content.collapsed .sidebar-section-header .section-icon {
          font-size: 1rem;
          opacity: 0.4;
          width: auto;
        }
        .glass-sidebar-content.collapsed .sidebar-section-header:hover .section-icon {
          opacity: 1;
          color: var(--accent-cyan);
        }
        .glass-sidebar-content.collapsed .sidebar-section-content {
          max-height: 0 !important;
          opacity: 0 !important;
        }

        /* Tooltips */
        .glass-sidebar-content.collapsed .nav-link-glass[data-tooltip]:hover::before,
        .glass-sidebar-content.collapsed .nav-link-glass[data-tooltip]:hover::after {
          opacity: 1;
          visibility: visible;
          transform: translateY(-50%) scale(1);
        }
        .glass-sidebar-content.collapsed .nav-link-glass[data-tooltip]::before {
          content: attr(data-tooltip);
          position: absolute;
          left: calc(100% + 14px);
          top: 50%;
          transform: translateY(-50%) scale(0.8);
          padding: 6px 16px;
          border-radius: 10px;
          background: rgba(8, 15, 35, 0.95);
          backdrop-filter: blur(12px);
          color: white;
          font-size: 0.8rem;
          font-weight: 500;
          white-space: nowrap;
          border: 1px solid rgba(59, 130, 246, 0.15);
          box-shadow: 0 8px 30px rgba(0,0,0,0.5);
          z-index: 999;
          transition: all 0.25s var(--transition-smooth);
          opacity: 0;
          visibility: hidden;
        }
        .glass-sidebar-content.collapsed .nav-link-glass[data-tooltip]::after {
          content: '';
          position: absolute;
          left: calc(100% + 8px);
          top: 50%;
          transform: translateY(-50%) scale(0);
          border-top: 5px solid transparent;
          border-bottom: 5px solid transparent;
          border-right: 5px solid rgba(8, 15, 35, 0.95);
          transition: all 0.25s var(--transition-smooth);
          opacity: 0;
          visibility: hidden;
        }

        /* ============================================================
           FOOTER – CARTE PROFIL
           ============================================================ */
        .sidebar-footer {
          flex-shrink: 0;
          padding: 12px 16px;
          margin-top: auto;
          border-top: 1px solid rgba(255,255,255,0.03);
          background: rgba(0, 10, 30, 0.2);
          backdrop-filter: blur(4px);
        }
        .glass-sidebar-content.collapsed .sidebar-footer {
          padding: 12px 4px;
          display: flex;
          justify-content: center;
        }

        .profile-card {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 8px 12px;
          border-radius: var(--radius-md);
          transition: 0.3s ease;
          background: rgba(255,255,255,0.02);
          border: 1px solid transparent;
          cursor: default;
        }
        .profile-card:hover {
          background: rgba(255,255,255,0.04);
          border-color: rgba(255,255,255,0.04);
        }

        .profile-avatar {
          width: 40px;
          height: 40px;
          border-radius: 12px;
          background: linear-gradient(135deg, var(--primary-blue), var(--accent-cyan));
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 1rem;
          color: white;
          flex-shrink: 0;
          box-shadow: 0 4px 12px var(--primary-glow);
        }
        .profile-info {
          flex: 1;
          overflow: hidden;
        }
        .profile-info .name {
          font-size: 0.85rem;
          font-weight: 600;
          color: white;
        }
        .profile-info .role {
          font-size: 0.65rem;
          font-weight: 500;
          color: var(--text-muted);
          opacity: 0.7;
        }

        .glass-sidebar-content.collapsed .profile-card {
          padding: 4px;
          justify-content: center;
          border-radius: 50%;
        }
        .glass-sidebar-content.collapsed .profile-info {
          display: none;
        }
        .glass-sidebar-content.collapsed .profile-avatar {
          width: 36px;
          height: 36px;
          border-radius: 10px;
        }

        /* Animations */
        .glass-sidebar-content {
          animation: sidebarFadeIn 0.6s ease;
        }
        @keyframes sidebarFadeIn {
          from { opacity: 0; transform: translateX(-20px); }
          to { opacity: 1; transform: translateX(0); }
        }

        @media (max-width: 992px) {
          .glass-sidebar-content { width: 260px; border-radius: 0 24px 24px 0; }
          .glass-sidebar-content.collapsed { width: 72px; }
        }
        @media (max-width: 768px) {
          .glass-sidebar-content { width: 100%; border-radius: 0; }
          .glass-sidebar-content.collapsed { width: 72px; }
          .toggle-handle { display: none; }
        }
      `}</style>

      {/* --- SIDEBAR CONTENT --- */}
      <div className={`glass-sidebar-content ${isCollapsed ? 'collapsed' : ''}`}>
        
        {/* Toggle Handle */}
        <button className="toggle-handle" onClick={() => setIsCollapsed(!isCollapsed)}>
          <FontAwesomeIcon icon={isCollapsed ? faChevronRight : faChevronLeft} />
        </button>

        {/* Header / Brand */}
        <div className="sidebar-header">
          <div className="app-brand">
            <div className="brand-icon-wrapper">
              <FontAwesomeIcon icon={faLayerGroup} />
            </div>
            {!isCollapsed && (
              <div>
                <div className="brand-text">
                  BISEN<span className="brand-highlight">TER</span>
                </div>
                <div className="brand-sub">Enterprise Resource Planning</div>
              </div>
            )}
          </div>
        </div>

        {/* Navigation Sections */}
        <div className="sidebar-scroll">
          {SECTION_CONFIG.map((section) => {
            const isActive = isSectionActive(section.items);
            const isExpanded = expandedSections[section.id] !== false;

            return (
              <div key={section.id} className="sidebar-section">
                <button
                  className={`sidebar-section-header ${isActive ? 'active' : ''}`}
                  onClick={() => !isCollapsed && toggleSection(section.id)}
                  disabled={isCollapsed}
                >
                  <span className="section-indicator" />
                  <span className="section-icon">
                    <FontAwesomeIcon icon={section.icon} />
                  </span>
                  <span className="section-label">{section.label}</span>
                  <span className={`section-chevron ${isExpanded ? 'open' : ''}`}>
                    <FontAwesomeIcon icon={faChevronDown} />
                  </span>
                </button>

                <div className={`sidebar-section-content ${isExpanded && !isCollapsed ? 'open' : ''}`}>
                  {section.items.map((item) => (
                    <NavLink
                      key={item.to}
                      to={item.to}
                      className={({ isActive }) =>
                        `nav-link-glass ${isActive ? 'active' : ''}`
                      }
                      onClick={handleLinkClick}
                      data-tooltip={item.label}
                    >
                      <span className="link-icon">
                        <FontAwesomeIcon icon={item.icon} />
                      </span>
                      <span className="link-text">{item.label}</span>
                      <span className="link-chevron">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </span>
                    </NavLink>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Footer / Profil */}
        <div className="sidebar-footer">
          <div className="profile-card">
            <div className="profile-avatar">{userInitial}</div>
            {!isCollapsed && (
              <div className="profile-info">
                <div className="name">{fonction || 'Utilisateur'}</div>
                <div className="role">Rôle</div>
              </div>
            )}
            {!isCollapsed && (
              <FontAwesomeIcon icon={faUserGear} style={{ opacity: 0.3, fontSize: '0.9rem', color: 'var(--text-muted)' }} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarSuperVisor;